import { z } from "zod";
import { CardModelSchema } from "./CardModel";

export const CardDetailsModelSchema = z.object({
  cards: z.array(CardModelSchema).nullable(),
  activeCardIndex: z.number().nullable(),
  sectionComplete: z.boolean().nullable(),
});
